import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "../Components/Axios/Axios";
import { Container, Button, Card, Form, Col, Row } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../Components/Sidebar/MainSidebar/Sidebar";
import Loader from "../Components/Spinner/Spinner";
import requests from "../Components/Requests/Requests";
import { useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles

function EditFaq(props) {
  const history = useHistory();
  const data = props.location.state;
  console.log(data, "rrrrrrrrrrrrrrrrr");
  const allTypes = ["android", "ios", "macos", "windows", "webapp"];
  const [title, setTitle] = useState("");
  const [id, setId] = useState(0);
  const [titles, setTitles] = useState({});
  const [transData, setTransData] = useState({});
  const [categoriesData, setCategoriesData] = useState([]);
  const [descriptions, setDescriptions] = useState({});
  const [shortdesc, setShortDesc] = useState("");
  const [editorValue, setEditorValue] = useState("");
  const [status, setStatus] = useState("1");
  const [category_id, setCategory_id] = useState("");
  const [type, setType] = useState("");
  const [icon, setIcon] = useState("");
  const [faqVideo, setFaqVideo] = useState("");
  const [faqkeywords, setFaqkeywords] = useState("");
  const [loading, setLoading] = useState(false);
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");

  useEffect(() => {
    console.log(transData, "trasdata");
  }, [transData]);
  const LANGUAGES = [
    { key: "english", label: "English", code: "en" },
    { key: "russian", label: "Russian", code: "ru" },
    { key: "portuguese", label: "Portuguese", code: "pt" },
    { key: "german", label: "German", code: "de" },

    { key: "french", label: "French", code: "fr" },
    { key: "spanish", label: "Spanish", code: "es" },
    { key: "kazakh", label: "Kazakh", code: "kk" },
    { key: "hindi", label: "Hindi", code: "hi" },

    { key: "chinese_simplified", label: "Chinese (Simplified)", code: "zh-CN" },
    {
      key: "chinese_traditional",
      label: "Chinese (Traditional)",
      code: "zh-TW",
    },

    { key: "ukrainian", label: "Ukrainian", code: "uk" },
    { key: "arabic", label: "Arabic", code: "ar" },
    { key: "turkish", label: "Turkish", code: "tr" },
    { key: "hebrew", label: "Hebrew", code: "he" },

    { key: "italian", label: "Italian", code: "it" },
    { key: "catalan", label: "Catalan", code: "ca" },
    { key: "croatian", label: "Croatian", code: "hr" },
    { key: "czech", label: "Czech", code: "cs" },

    { key: "danish", label: "Danish", code: "da" },
    { key: "dutch", label: "Dutch", code: "nl" },
    { key: "finnish", label: "Finnish", code: "fi" },
    { key: "greek", label: "Greek", code: "el" },

    { key: "hungarian", label: "Hungarian", code: "hu" },
    { key: "norwegian", label: "Norwegian", code: "no" },
    { key: "polish", label: "Polish", code: "pl" },
    { key: "romanian", label: "Romanian", code: "ro" },

    { key: "slovak", label: "Slovak", code: "sk" },
    { key: "swedish", label: "Swedish", code: "sv" },
    { key: "korean", label: "Korean", code: "ko" },
    { key: "thai", label: "Thai", code: "th" },

    { key: "vietnamese", label: "Vietnamese", code: "vi" },
    { key: "japanese", label: "Japanese", code: "ja" },
    { key: "indonesian", label: "Indonesian", code: "id" },
    { key: "malay", label: "Malay", code: "ms" },
  ];

  console.log("props.....", data);
  // const handleCheckboxChange = (e) => {
  //   const value = e.target.value;

  //   let updated = [...selectedTypes];

  //   if (updated.includes(value)) {
  //     updated = updated.filter((item) => item !== value);
  //   } else {
  //     updated.push(value);
  //   }

  //   setSelectedTypes(updated);
  // };
  //   const handleCheckboxChange = (e) => {
  //     const { value, checked } = e.target;

  //     setSelectedTypes((prev) => {
  //       if (checked) {
  //         return [...prev, value]; // add
  //       } else {
  //         return prev.filter((item) => item !== value); // remove
  //       }
  //     });
  //   };

  useEffect(() => {
    getAllFaqtranslations();
  }, []);
  const getAllFaqtranslations = async () => {
    try {
      const responce = await axios.get(requests.getcategory);
      // console.log(responce);
      if (responce.data.Success === 1) {
        const transdata = responce.data.data;
        setCategoriesData(transdata);
        setCategory_id(transdata[0].id);
      } else {
        toast.warning(`Something went wrong`, {
          position: "top-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (err) {
      toast.warning(err, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const addNewFaq = async () => {
    // const formData = new FormData();
    // formData.append("id", id);
    // formData.append("que", title);
    // formData.append("ans", editorValue);

    // formData.append("status", status);
    // formData.append("type",type);
    if (window.navigator.onLine) {
      setLoading(true);
      const formData = new FormData();
      formData.append("que", title);
      formData.append(
        "slug",
        title
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/gi, "") // remove ALL special characters
          .trim() // remove starting/ending spaces
          .replace(/\s+/g, "-") // convert spaces to hyphens
          .replace(/-+/g, "-") // remove multiple hyphens
      );

      formData.append("ans", editorValue);
      formData.append("shortdesc", shortdesc);
      formData.append("status", status.toString());
      formData.append("categoryId", category_id);
      //   formData.append("type", selectedTypes.join(", "));
      formData.append("transData", JSON.stringify(transData));
      formData.append("metatitle", metaTitle);
      formData.append("metadesc", metaDesc);
      //   formData.append("keywords", faqkeywords);

      formData.append("icon", icon);

      //   formData.append("video", faqVideo);
      try {
        const responce = await axios.post(requests.addLesson, formData);
        // console.log("result........",responce);
        if (responce.data.Success === 1) {
          // console.log(responce);
          toast.success("Lesson added successfully!!", {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setTimeout(() => {
            history.push("/allLessons");
          }, 2500);
        } else {
          setLoading(false);
          toast.warning(`Something went wrong`, {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (err) {
        toast.warning(err, {
          position: "top-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      // console.log("body.....", body);
    } else {
      toast.error(`No internet connection`, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  return (
    <>
      <Sidebar />
      <Container className="content">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Card>
          <Card.Header className="heading">Add Lesson</Card.Header>
          <Card.Body>
            <Row>
              <Col className="main">
                {/* <Form.Group className="mb-3">
                  <Form.Label>
                    Type <span className="mandatory">*</span>
                  </Form.Label>
                  {allTypes.map((type) => (
                    <Form.Check
                      key={type}
                      type="checkbox"
                      label={type}
                      value={type}
                      checked={selectedTypes.includes(type)}
                      onChange={handleCheckboxChange}
                    />
                  ))}
                </Form.Group> */}
                <Form.Group className="mb-3">
                  <Form.Label>Lesson Image</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    placeholder="Lesson Image"
                    onChange={(e) => {
                      e.target.files[0] == undefined
                        ? setIcon("")
                        : setIcon(e.target.files[0]);
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Meta Title <span className="mandatory">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Meta Title"
                    onChange={(e) => setMetaTitle(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Meta Description <span className="mandatory">*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Meta Description"
                    onChange={(e) => setMetaDesc(e.target.value)}
                  />
                </Form.Group>

                {/* <Form.Group className="mb-3">
                  <Form.Label>FAQ Video</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="FAQ Video"
                    value={faqVideo}
                    onChange={(e) => setFaqVideo(e.target.value)}
                  />
                </Form.Group> */}

                {/* <Form.Group className="mb-3">
                  <Form.Label>FAQ Keywords</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="FAQ Keyword(Comma separated)"
                    value={faqkeywords}
                    onChange={(e) => setFaqkeywords(e.target.value)}
                  />
                </Form.Group> */}

                {LANGUAGES.map((lang) => {
                  const t = transData[lang.code] || {}; // get API value for this language

                  return (
                    <div key={lang.code}>
                      {/* Title */}
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Title{" "}
                          {lang.label === "English" ? (
                            <span className="mandatory">*</span>
                          ) : (
                            ""
                          )}{" "}
                          ({lang.label})
                        </Form.Label>

                        <Form.Control
                          type="text"
                          placeholder={`Title in ${lang.label}`}
                          value={
                            lang.label == "English" ? title : t.title || ""
                          } // AUTO-FILL HERE
                          onChange={(e) => {
                            const value = e.target.value;
                            // update translations
                            if (lang.label !== "English") {
                              setTransData((prev) => ({
                                ...prev,
                                [lang.code]: {
                                  ...prev[lang.code],
                                  lang_code: lang.code,
                                  title: value,
                                  description:
                                    prev[lang.code]?.description || "",
                                },
                              }));
                            } else {
                              setTitle(value);
                            }
                          }}
                        />
                      </Form.Group>

                      {/* Description */}
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Description{" "}
                          {lang.label === "English" ? (
                            <span className="mandatory">*</span>
                          ) : (
                            ""
                          )}{" "}
                          ({lang.label})
                        </Form.Label>

                        {lang.label == "English" ? (
                          <ReactQuill
                            value={editorValue}
                            onChange={(content) => setEditorValue(content)}
                          />
                        ) : (
                          <ReactQuill
                            value={t.description || ""}
                            onChange={(content) =>
                              setTransData((prev) => ({
                                ...prev,
                                [lang.code]: {
                                  ...prev[lang.code],
                                  lang_code: lang.code,
                                  title: prev[lang.code]?.title || "",
                                  subtopics: prev[lang.code]?.subtopics || "",
                                  description: content,
                                },
                              }))
                            }
                          />
                        )}
                      </Form.Group>
                      {/* Short Description */}
                      <Form.Group className="mb-3">
                        <Form.Label>
                          SubTopic
                          {lang.label === "English" ? (
                            <span className="mandatory">*</span>
                          ) : (
                            ""
                          )}{" "}
                          ({lang.label})
                        </Form.Label>

                        {lang.label == "English" ? (
                          <ReactQuill
                            value={shortdesc}
                            onChange={(content) => setShortDesc(content)}
                          />
                        ) : (
                          <ReactQuill
                            value={t.subtopics || ""}
                            onChange={(content) =>
                              setTransData((prev) => ({
                                ...prev,
                                [lang.code]: {
                                  ...prev[lang.code],
                                  lang_code: lang.code,
                                  title: prev[lang.code]?.title || "",
                                  description:
                                    prev[lang.code]?.description || "",
                                  subtopics: content,
                                },
                              }))
                            }
                          />
                        )}
                      </Form.Group>
                    </div>
                  );
                })}

                <Form.Group className="mb-3">
                  <Form.Label>
                    Category <span className="mandatory">*</span>
                  </Form.Label>
                  <Form.Select
                    value={category_id}
                    onChange={(e) => setCategory_id(e.target.value)}
                  >
                    {categoriesData.map((data) => {
                      return <option value={data.id}>{data.name_en}</option>;
                    })}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    Status <span className="mandatory">*</span>
                  </Form.Label>
                  <Form.Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="0">Inactive</option>
                    <option value="1">Active</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className="footer">
            {loading == true ? (
              <Loader margin={0} />
            ) : (
              <Button
                className="submit-btn"
                onClick={() => addNewFaq()}
                variant="primary"
              >
                Submit
              </Button>
            )}
          </Card.Footer>
        </Card>
      </Container>
    </>
  );
}

export default EditFaq;
